export default "__VITE_ASSET__sqcXp1t___"